import dv from './client';
import { fetchAPI, parseUserResponse } from '../utils';
const opts = {
    headers: {
        Accept: `application/vnd.newbay.dv-1.26+json`,
        'Content-Type': `application/vnd.newbay.dv-1.26+json`,
    },
};
const apiType = 'dv';
export const repositoryOpts = {
    headers: {
        Accept: `application/vnd.newbay.dv-1.28+json`,
        'Content-Type': `application/x-www-form-urlencoded`,
    },
};
export const fetchUsage = (logger) => {
    logger ? dv.setLogger(logger) : undefined;
    return dv.get('/user/{userId}/usage', apiType, opts);
};
export const fetchUser = (logger) => {
    logger ? dv.setLogger(logger) : undefined;
    return dv.get('/user/{userId}', apiType, opts);
};
export const fetchRepositories = async (logger) => {
    logger ? dv.setLogger(logger) : undefined;
    return dv.get('/user/{userId}/repository', apiType, opts);
};
export const fetchApi = async (params, endpoint, headers = {}, withOutUserId = false, logger) => {
    logger ? dv.setLogger(logger) : undefined;
    return fetchAPI(withOutUserId ? `/${endpoint}` : `/user/{userId}/${endpoint}`, apiType, params, {
        ...opts.headers,
        ...headers,
    });
};
export const postApi = async (body, endpoint, headers = {}, logger) => {
    logger ? dv.setLogger(logger) : undefined;
    return dv.post(`/user/{userId}/${endpoint}`, apiType, {
        data: body,
        ...opts,
        headers: { ...opts.headers, ...headers },
    });
};
export const postSharedApi = async (body, endpoint, headers = {}, logger) => {
    logger ? dv.setLogger(logger) : undefined;
    return dv.post(`${endpoint}`, apiType, {
        data: body,
        ...opts,
        headers: { ...opts.headers, ...headers },
    });
};
export const getFileMetadata = async (collections, logger, shared) => {
    logger ? dv.setLogger(logger) : undefined;
    const nameSpace = {
        dvi: 'http://internal.dv.newbay.com/ns/1.0',
        a: 'http://alternate.newbay.com/ns/1.0',
        $: 'http://dv.newbay.com/ns/1.0',
    };
    const body = shared
        ? {
            nodesLookup: {
                '@xmlns': nameSpace,
                nodeUris: collections,
            },
        }
        : {
            repositoryNamesAndNodeIds: {
                '@xmlns': nameSpace,
                repositoryNameAndNodeIds: collections,
            },
        };
    if (shared) {
        return postSharedApi(body, '/file/nodeuris');
    }
    return postApi(body, 'file/nodeid');
};
export const fetchUserFiles = async (params, endpoint, logger) => {
    logger ? dv.setLogger(logger) : undefined;
    const { filesHolder } = await fetchApi(params, endpoint);
    const cursor = filesHolder.cursor?.$;
    return parseUserResponse(cursor, filesHolder.files, () => fetchUserFiles({ ...params, cursor }, endpoint));
};
export const deleteApi = async (endpoint, params, headers = {}, logger) => {
    logger ? dv.setLogger(logger) : undefined;
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!value) {
            if (value instanceof Array) {
                value.map((item) => query.append(key, item.toString()));
            }
            else {
                query.set(key, value.toString());
            }
        }
    });
    return dv.delete(`/user/{userId}/${endpoint}?${query.toString()}`, apiType, {
        ...opts,
        headers: { ...opts.headers, ...headers },
    });
};
